jQuery(document).ready(function() {
    LTUDS.setupComponents();
});